//#region importsSection
import React, { useEffect, useState } from "react";
import {
  Button,
  Spinner,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Card,
  CardBody,
} from "reactstrap";
import { GetLanguageString } from "../helper/Components";
import swal from "sweetalert";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import { LoadingSpinner } from "../../constants/const";
import { ApiFund } from "../funds/ApiFund";
import { ApiDocuments } from "../documents/ApiDocuments";
//#endregion

//#region styles (Pattern matched to reference)
const cardStyle = (borderColor) => ({
  borderRadius: "12px",
  border: "1px solid #E5E7EB",
  borderLeft: `4px solid ${borderColor}`,
  background: "#FFFFFF",
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  marginBottom: "16px",
});

const labelStyle = {
  fontSize: "11px",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  color: "#9CA3AF",
  marginBottom: "4px",
};

const valueStyle = {
  fontSize: "14px",
  fontWeight: 600,
  color: "#1F2937",
  lineHeight: "1.4",
};

const sectionHeaderStyle = (color) => ({
  fontSize: "13px",
  fontWeight: 700,
  letterSpacing: "0.05em",
  color: color,
  textTransform: "uppercase",
  marginBottom: "16px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

const animatedBody = {
  animation: "fadeSlideIn 0.25s ease-out",
  padding: "20px 24px",
};

const amountBadgeStyle = {
  display: "inline-block",
  padding: "4px 12px",
  borderRadius: "30px",
  backgroundColor: "#EFF6FF",
  color: "#2563EB",
  fontWeight: 700,
  fontSize: "14px",
  border: "1px solid #BFDBFE",
};

const btnStyle = {
  padding: "6px 14px",
  borderRadius: "8px",
  fontWeight: 600,
  fontSize: "13px",
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  transition: "all 0.2s",
};
//#endregion

const FundsInfaqAmanatViewForm = ({
  setViewInfaqAmanatForm,
  notificationId,
}) => {
  const { t } = useTranslation();
  const [notificationresponse, setNotificationresponse] = useState({});
  const [loading, setLoading] = useState(false);
  const [viewButtonDisable, setViewButtonDisable] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const toggle = () => setViewInfaqAmanatForm(false);

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleDrag = (e, ui) =>
    setPosition((p) => ({ x: p.x + ui.deltaX, y: p.y + ui.deltaY }));

  useEffect(() => {
    if (!notificationId) return;
    setLoading(true);
    ApiFund()
      .getInfaqRequestDetail(notificationId)
      .then((res) => {
        if (res.data) setNotificationresponse(res.data || {});
      })
      .finally(() => setLoading(false));
  }, [notificationId]);

  const openFile = (fileUrl) => {
    setViewButtonDisable(true);
    try {
      window.open(fileUrl, "_blank");
    } catch (err) {
      swal({ title: "Error opening file", icon: "error", buttons: "OK" });
    } finally {
      setViewButtonDisable(false);
    }
  };

  const downloadFile = async (fileId) => {
    setButtonDisable(true);
    try {
      const response = await ApiDocuments().downloadDocument(fileId);
      if (response.status === 200) {
        window.location.href = `${response.data.downloadLink}&confirm=t`;
      } else {
        swal({ title: t(response.data), icon: "error", buttons: "OK" });
      }
    } catch (error) {
      swal({ title: error.message, icon: "error", buttons: "OK" });
    } finally {
      setButtonDisable(false);
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes fadeSlideIn {
            from { opacity: 0; transform: translateY(8px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .inmodal .modal-content {
            border-radius: 16px !important;
            border: none !important;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
            overflow: hidden;
          }
          .inmodal .modal-header {
            background-color: #F9FAFB !important;
            border-bottom: 1px solid #F3F4F6 !important;
            padding: 16px 24px !important;
          }
          .inmodal .modal-footer {
            background-color: #F9FAFB !important;
            border-top: 1px solid #F3F4F6 !important;
            padding: 16px 24px !important;
          }
          .inmodal .modal-title {
            font-weight: 700 !important;
            font-size: 16px !important;
            color: #111827 !important;
            display: flex;
            align-items: center;
            gap: 8px;
          }
        `}
      </style>

      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal size="lg" isOpen className="inmodal">
          <ModalHeader className="modal-title">
            <i className="fa fa-exchange-alt text-primary"></i>
            <span>
              <GetLanguageString props="common_changes" />
            </span>
          </ModalHeader>

          {loading ? (
            <ModalBody className="text-center py-4">
              <LoadingSpinner />
            </ModalBody>
          ) : (
            <ModalBody style={animatedBody}>
              {/* MEMBER & ACCOUNT INFO SECTION */}
              <Card style={cardStyle("#3B82F6")}>
                <CardBody style={{ padding: "20px 24px" }}>
                  <div style={sectionHeaderStyle("#2563EB")}>
                    <i className="fa fa-info-circle" style={{ fontSize: "15px" }}></i>
                    Request Information
                  </div>
                  <Row className="gy-3">
                    <Col md="4">
                      <div style={labelStyle}>Member Name</div>
                      <div className="ur" style={valueStyle}>
                        {notificationresponse.memberName}
                      </div>
                    </Col>
                    <Col md="4">
                      <div style={labelStyle}>To Bank Account</div>
                      <div style={valueStyle}>
                        {notificationresponse.toBankAccount}
                      </div>
                    </Col>
                    <Col md="4">
                      <div style={labelStyle}>Account Head</div>
                      <div style={valueStyle}>
                        {notificationresponse.accountHead || "Multiple Heads"}
                      </div>
                    </Col>
                    <Col md="4">
                      <div style={labelStyle}>Reference</div>
                      <div style={valueStyle}>
                        {notificationresponse.reference}
                      </div>
                    </Col>
                    <Col md="4">
                      <div style={labelStyle}>Date</div>
                      <div style={valueStyle}>{notificationresponse.date}</div>
                    </Col>
                    <Col md="4">
                      <div style={labelStyle}>Total Amount</div>
                      <div>
                        <div style={amountBadgeStyle}>
                          {new Intl.NumberFormat().format(
                            notificationresponse.amount || 0
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {/* DETAILS SECTION FOR MULTIPLE ENTRIES */}
              {notificationresponse.entries && notificationresponse.entries.length > 1 && (
                <Card style={cardStyle("#10B981")}>
                  <CardBody style={{ padding: "20px 24px" }}>
                    <div style={sectionHeaderStyle("#059669")}>
                      <i className="fa fa-list" style={{ fontSize: "15px" }}></i>
                      <GetLanguageString props="finance_infaq_entry_details" />
                    </div>
                    <div className="table-responsive no-drag" style={{ borderRadius: "8px", border: "1px solid #E5E7EB", overflow: "hidden" }}>
                      <table className="table table-hover align-middle mb-0" style={{ fontSize: "13px", borderCollapse: "separate" }}>
                        <thead>
                          <tr style={{ background: "#F9FAFB", borderBottom: "2px solid #E5E7EB" }}>
                            <th style={{ padding: "10px 16px", fontWeight: 600, color: "#4B5563" }}>#</th>
                            <th style={{ padding: "10px 16px", fontWeight: 600, color: "#4B5563" }}>{<GetLanguageString props="fund_account_head" />}</th>
                            <th className="text-end" style={{ padding: "10px 16px", fontWeight: 600, color: "#4B5563" }}>{<GetLanguageString props="funds_add_fund_amount" />}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {notificationresponse.entries.map((entry, index) => (
                            <tr key={index} style={{ borderBottom: "1px solid #F3F4F6" }}>
                              <td style={{ padding: "10px 16px", color: "#6B7280", fontWeight: 500 }}>{index + 1}</td>
                              <td style={{ padding: "10px 16px", color: "#1F2937", fontWeight: 600 }}>{entry.accountHead}</td>
                              <td className="text-end" style={{ padding: "10px 16px", color: "#111827", fontWeight: 700, fontSize: "14px" }}>
                                {new Intl.NumberFormat().format(entry.amount || 0)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              )}

              {/* ATTACHMENT SECTION */}
              {notificationresponse.approvalFile && (
                <Card style={cardStyle("#0EA5E9")}>
                  <CardBody className="d-flex justify-content-between align-items-center" style={{ padding: "20px 24px" }}>
                    <div>
                      <div style={sectionHeaderStyle("#0284C7")}>
                        <i className="fa fa-paperclip" style={{ fontSize: "15px" }}></i>
                        <GetLanguageString props="attachment" />
                      </div>
                      <div style={valueStyle}>Approval Document</div>
                    </div>

                    <div className="no-drag d-flex gap-2">
                      <Button
                        color="white"
                        disabled={viewButtonDisable}
                        size="sm"
                        style={{ ...btnStyle, border: "1px solid #D1D5DB" }}
                        onClick={() =>
                          openFile(notificationresponse.approvalFile)
                        }
                      >
                        {viewButtonDisable ? (
                          <Spinner size="sm" color="primary" />
                        ) : (
                          <>
                            <i className="fa fa-eye text-primary"></i>
                            <GetLanguageString props="member_add_rafiq_request_view_document" />
                          </>
                        )}
                      </Button>
                      <Button
                        color="white"
                        size="sm"
                        style={{ ...btnStyle, border: "1px solid #D1D5DB" }}
                        disabled={buttonDisable}
                        onClick={() =>
                          downloadFile(notificationresponse.approvalFileDriveId)
                        }
                      >
                        {buttonDisable ? (
                          <Spinner size="sm" color="success" />
                        ) : (
                          <>
                            <i className="fa fa-download text-success"></i>
                            <GetLanguageString props="member_add_rafiq_request_download_document" />
                          </>
                        )}
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              )}
            </ModalBody>
          )}

          <ModalFooter>
            <Button
              color="primary"
              style={{ borderRadius: "8px", padding: "8px 24px", fontWeight: 600 }}
              onClick={toggle}
            >
              <GetLanguageString props="users_role_ok_btn" />
            </Button>
          </ModalFooter>
        </Modal>
      </Draggable>
    </>
  );
};

export default FundsInfaqAmanatViewForm;
